export function getPosts(state) {
  return state.posts;
}
export function getSelectedPost(state) {
  return state.selectedPost;
}

export function corporatePost(state) {
  return state.posts.filter(
    post => post.post_type == 'Corporativas'
  )
}

export function miscellaneousPost(state) {
  return state.posts.filter(
    post => post.post_type == 'Miscelaneos'
  )
}

export function knowingUsPost(state) {
  return state.posts.filter(
    post => post.post_type == 'Conociéndonos'
  )
}